"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectToken = void 0;
const base_1 = require("./base");
class IkeObjectToken extends base_1.IkeRestObject {
    constructor() {
        super(...arguments);
        this.className = 'Token';
        this.actionName = 'token';
    }
}
exports.IkeObjectToken = IkeObjectToken;
//# sourceMappingURL=token.object.js.map